import { useLocation } from 'react-router-dom';

/**
 * Route prefixes on which ALL visible global direct-message presentation is
 * suppressed: the live table (playing or spectating) and the tutorial. While
 * suppressed, the Sidebar Chat module, dock windows, minimized tabs, DM
 * preview toasts and any future DM sound stay hidden/silent — but the
 * FriendChannel subscription, message caches and unread counts keep updating
 * silently, and no dock window state is closed or mutated. Leaving a
 * suppressed route restores the exact prior dock state.
 *
 * This is the ONE stable seam for that decision — route matching must not be
 * re-derived ad hoc elsewhere. Matching mirrors the shell's existing
 * route-prefix gates (see ActiveGameBanner's pathname.startsWith('/game')).
 */
const DM_SUPPRESSED_PREFIXES = ['/game', '/spectate', '/tutorial'];

/** Pure predicate — exported for tests and non-hook callers. */
export function isDmSuppressedPath(pathname: string): boolean {
  return DM_SUPPRESSED_PREFIXES.some(p => pathname === p || pathname.startsWith(p + '/'));
}

/**
 * True while the current route must not show any global-DM presentation.
 * Only suppresses direct-message presentation — friendship, invitation,
 * achievement and connection toasts are NOT gated by this seam.
 */
export function useDmPresentationSuppressed(): boolean {
  const { pathname } = useLocation();
  return isDmSuppressedPath(pathname);
}
